/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var gramatica = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,5],$V1=[1,6],$V2=[1,17],$V3=[1,16],$V4=[1,18],$V5=[1,19],$V6=[1,20],$V7=[1,21],$V8=[1,22],$V9=[1,23],$Va=[1,24],$Vb=[1,25],$Vc=[1,26],$Vd=[1,27],$Ve=[1,28],$Vf=[1,29],$Vg=[1,30],$Vh=[1,31],$Vi=[1,32],$Vj=[1,12],$Vk=[1,13],$Vl=[1,14],$Vm=[1,15],$Vn=[5,6],$Vo=[1,35],$Vp=[1,36],$Vq=[5,6,8,9,17,36,37,38,39,40,41,42,43,44,45,46,47,60],$Vr=[1,59],$Vs=[1,60],$Vt=[1,61],$Vu=[1,62],$Vv=[1,67],$Vw=[1,65],$Vx=[1,66],$Vy=[1,68],$Vz=[1,69],$VA=[1,70],$VB=[1,71],$VC=[1,72],$VD=[1,73],$VE=[1,74],$VF=[1,75],$VG=[1,76],$VH=[1,77],$VI=[17,36,37,38,39,40,41,42,43,44,45,46,47,60],$VJ=[36,37,39,40,41,42,43,44,45,46,60],$VK=[39,40,41,42,43,44,45,46,60];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"XPATH":3,"OPERACIONOR":4,"EOF":5,"simpleor":6,"PATHRELL1":7,"sdiagonal":8,"ddiagonal":9,"PATHRELL2":10,"EXPRESION":11,"AXISNAME":12,"METODO":13,"ACCES":14,"identifier":15,"arroba":16,"mul":17,"spunto":18,"dpunto":19,"NAMEAXIS":20,"ddospuntos":21,"ancestor":22,"ancestor_or_self":23,"attribute":24,"child":25,"descendant":26,"descendant_or_self":27,"following":28,"following_sibling":29,"namespace_node":30,"parent":31,"preceding":32,"preceding_sibling":33,"self":34,"OPERACION":35,"mas":36,"menos":37,"div_":38,"igual":39,"diferente":40,"menorq":41,"menorigual":42,"mayorq":43,"mayorigual":44,"or_":45,"and_":46,"mod_":47,"OPERAD":48,"DecimalLiteral":49,"IntegerLiteral":50,"StringLiteral":51,"CharLiteral":52,"text":53,"lparen":54,"rparen":55,"node":56,"last":57,"position":58,"lcorchete":59,"rcorchete":60,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"simpleor",8:"sdiagonal",9:"ddiagonal",15:"identifier",16:"arroba",17:"mul",18:"spunto",19:"dpunto",21:"ddospuntos",22:"ancestor",23:"ancestor_or_self",24:"attribute",25:"child",26:"descendant",27:"descendant_or_self",28:"following",29:"following_sibling",30:"namespace_node",31:"parent",32:"preceding",33:"preceding_sibling",34:"self",36:"mas",37:"menos",38:"div_",39:"igual",40:"diferente",41:"menorq",42:"menorigual",43:"mayorq",44:"mayorigual",45:"or_",46:"and_",47:"mod_",49:"DecimalLiteral",50:"IntegerLiteral",51:"StringLiteral",52:"CharLiteral",53:"text",54:"lparen",55:"rparen",56:"node",57:"last",58:"position",59:"lcorchete",60:"rcorchete"},
productions_: [0,[3,2],[4,3],[4,1],[7,3],[7,3],[7,1],[10,2],[10,2],[10,1],[11,1],[11,1],[11,1],[14,1],[14,2],[14,2],[14,1],[14,1],[12,3],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,1],[35,1],[48,1],[48,1],[48,1],[48,1],[13,3],[13,3],[13,3],[13,3],[13,5],[13,4]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
   
                                   this.$= new Nodo("INICIO","Xpath");
		                     this.$.addHijos($$[$0-1]);
                                   return { ErrorLexico:arreglolexico,msj:"Analisis XPath Ascendenete Finalizado.\n.",diagramaAST:this.$};
                     
break;
case 2:
 
                                                         this.$ = new Nodo($$[$0-1],"OPERACIONOR:simpleor");
                                                         this.$.addHijos($$[$0-2]);
                                                         this.$.addHijos($$[$0]);  
                                                         
break;
case 3:
 
                                   this.$ =$$[$0]; 
                                   
break;
case 4:
 
                                                 this.$ = new Nodo($$[$0-1],"PATHRELL1:sdiagonal");
                                                 this.$.addHijos($$[$0-2]); 
                                                 this.$.addHijos($$[$0]); 
                                              
break;
case 5:
 
                                                 this.$ = new Nodo($$[$0-1],"PATHRELL1:ddiagonal");
                                                 this.$.addHijos($$[$0-2]); 
                                                 this.$.addHijos($$[$0]); 
                                              
break;
case 6:
 
                                          this.$ = $$[$0];   
                                          
break;
case 7:
  
                                          this.$ = new Nodo($$[$0-1],"PATHRELL2:sdiagonal");   
                                          this.$.addHijos($$[$0]);    
                                   
break;
case 8:
  
                                          this.$ = new Nodo($$[$0-1],"PATHRELL2:ddiagonal");  
                                          this.$.addHijos($$[$0]); 
                                   
break;
case 9:
  
                                          this.$ = $$[$0];    
                                   
break;
case 10: case 12:
  
                            this.$ = $$[$0];   
                            
break;
case 11:
  
                            this.$ =$$[$0];   
                            
break;
case 13:
  
                            this.$ = new Nodo($$[$0],"ACCES:identificador");
                            
break;
case 14:
  
                            this.$ = new Nodo($$[$0-1]+$$[$0],"ACCES:arrobaidentificador");
                              
                            
break;
case 15:
  
                            this.$ = new Nodo($$[$0-1]+$$[$0],"ACCES:arrobamul");
                            
break;
case 16:
  
                            this.$ = new Nodo($$[$0],"ACCES:spunto");    
                            
break;
case 17:
  
                            this.$ = new Nodo($$[$0],"ACCES:dpunto");     
                            
break;
case 18:
  
                                          this.$ = new Nodo("Axis","AXISNAME:UNICO");
                                          this.$.addHijos($$[$0-2]);
                                          this.$.addHijos(new Nodo($$[$0-1],"AXISNAME:dospuntos"));  
                                          this.$.addHijos($$[$0]);    
                                          
break;
case 19:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:ancestor");
                            
break;
case 20:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:ancestor_or_self");
                            
break;
case 21:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:attribute");
                            
break;
case 22:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:child");
                            
break;
case 23:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:descendant");
                            
break;
case 24:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:descendant_or_self");
                            
break;
case 25:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:following");
                            
break;
case 26:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:following_sibling");
                            
break;
case 27:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:namespace_node");
                            
break;
case 28:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:parent");
                            
break;
case 29:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:preceding");
                            
break;
case 30:
    
                             this.$ = new Nodo($$[$0],"NAMEAXIS:preceding_sibling");
                            
break;
case 31:
    
                            this.$ = new Nodo($$[$0],"NAMEAXIS:self");
                            
break;
case 32:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:mas");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);    
                                                 
break;
case 33:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:menos");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);     
                                                 
break;
case 34:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:mul");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);    
                                                 
break;
case 35:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:div");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 36:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:igual");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 37:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:diferente");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 38:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:menorque");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 39:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:menorigual");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);       
                                                 
break;
case 40:
    
                                                  this.$ = new Nodo($$[$0-1],"OPERACION:mayorque");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 41:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:mayorigual");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 42:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:or");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);   
                                                 
break;
case 43:
    
                                                 this.$ = new Nodo($$[$0-1],"OPERACION:and");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);    
                                                 
break;
case 44:
    
                                                  this.$ = new Nodo($$[$0-1],"OPERACION:mod");
                                                 this.$.addHijos($$[$0-2]);
                                                 this.$.addHijos($$[$0]);      
                                                 
break;
case 45:
    
                                                 this.$ = $$[$0]  
                                                 
break;
case 46:
    
                                                 this.$ = $$[$0]   
                                                 
break;
case 47:
    
                            this.$ = new Nodo($$[$0],"OPERAD:decimal");
                            
break;
case 48:
    
                            this.$ = new Nodo($$[$0],"OPERAD:entero");
                            
break;
case 49:
    
                            this.$ = new Nodo($$[$0],"OPERAD:cadenaS"); 
                            
break;
case 50:
    
                            this.$ = new Nodo($$[$0],"OPERAD:cadenaC");
                            
break;
case 51:
this.$ = new Nodo($$[$0-2],"METODO:text");  
                            
break;
case 52:
this.$ = new Nodo($$[$0-2],"METODO:node");  
                            
break;
case 53:
this.$ = new Nodo($$[$0-2],"METODO:last");  
                            
break;
case 54:
this.$ = new Nodo($$[$0-2],"METODO:posicion");  
                            
break;
case 55:
      
                                                               this.$ = new Nodo($$[$0-4]+$$[$0-3],"METODO:atributo");
                                                               this.$.addHijos(new Nodo($$[$0-3],"METODO:lcorchete"));
                                                               this.$.addHijos($$[$0-2]);
                                                               this.$.addHijos(new Nodo($$[$0-1],"METODO:rcorchete"));
                                                        
break;
case 56:

                                                        this.$ = new Nodo($$[$0-3],"METODO:etiqueta");
                                                        this.$.addHijos(new Nodo($$[$0-2],"METODO:lcorchete"));
                                                        this.$.addHijos($$[$0-1]);
                                                        this.$.addHijos(new Nodo($$[$0],"METODO:rcorchete"));
                                                        
break;
}
},
table: [{3:1,4:2,7:3,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{1:[3]},{5:[1,33],6:[1,34]},o($Vn,[2,3],{8:$Vo,9:$Vp}),o($Vq,[2,6]),{11:37,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{11:38,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},o($Vq,[2,9]),o($Vq,[2,10]),o($Vq,[2,11]),o($Vq,[2,12]),{21:[1,39]},{54:[1,40]},{54:[1,41]},{54:[1,42]},{54:[1,43]},{15:[1,44],17:[1,45]},o($Vq,[2,13],{59:[1,46]}),o($Vq,[2,16]),o($Vq,[2,17]),{21:[2,19]},{21:[2,20]},{21:[2,21]},{21:[2,22]},{21:[2,23]},{21:[2,24]},{21:[2,25]},{21:[2,26]},{21:[2,27]},{21:[2,28]},{21:[2,29]},{21:[2,30]},{21:[2,31]},{1:[2,1]},{4:47,7:3,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:48,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:49,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},o($Vq,[2,7]),o($Vq,[2,8]),{11:50,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{55:[1,51]},{55:[1,52]},{55:[1,53]},{55:[1,54]},o($Vq,[2,14],{59:[1,55]}),o($Vq,[2,15]),{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:56,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},o($Vn,[2,2]),o($Vq,[2,4]),o($Vq,[2,5]),o($Vq,[2,18]),o($Vq,[2,51]),o($Vq,[2,52]),o($Vq,[2,53]),o($Vq,[2,54]),{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:63,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{17:$Vv,36:$Vw,37:$Vx,38:$Vy,39:$Vz,40:$VA,41:$VB,42:$VC,43:$VD,44:$VE,45:$VF,46:$VG,47:$VH,60:[1,64]},o($VI,[2,45]),o($VI,[2,46],{8:$Vo,9:$Vp}),o($VI,[2,47]),o($VI,[2,48]),o($VI,[2,49]),o($VI,[2,50]),{17:$Vv,36:$Vw,37:$Vx,38:$Vy,39:$Vz,40:$VA,41:$VB,42:$VC,43:$VD,44:$VE,45:$VF,46:$VG,47:$VH,60:[1,78]},o($Vq,[2,56]),{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:79,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:80,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:81,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:82,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:83,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:84,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:85,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:86,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:87,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:88,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:89,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:90,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},{7:58,8:$V0,9:$V1,10:4,11:7,12:8,13:9,14:10,15:$V2,16:$V3,18:$V4,19:$V5,20:11,22:$V6,23:$V7,24:$V8,25:$V9,26:$Va,27:$Vb,28:$Vc,29:$Vd,30:$Ve,31:$Vf,32:$Vg,33:$Vh,34:$Vi,35:91,48:57,49:$Vr,50:$Vs,51:$Vt,52:$Vu,53:$Vj,56:$Vk,57:$Vl,58:$Vm},o($Vq,[2,55]),o($VJ,[2,32],{17:$Vv,38:$Vy,47:$VH}),o($VJ,[2,33],{17:$Vv,38:$Vy,47:$VH}),o($VI,[2,34]),o($VI,[2,35]),o($VK,[2,36],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,47:$VH}),o($VK,[2,37],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,47:$VH}),o($VK,[2,38],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,47:$VH}),o($VK,[2,39],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,47:$VH}),o($VK,[2,40],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,47:$VH}),o($VK,[2,41],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,47:$VH}),o([45,60],[2,42],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,39:$Vz,40:$VA,41:$VB,42:$VC,43:$VD,44:$VE,46:$VG,47:$VH}),o([45,46,60],[2,43],{17:$Vv,36:$Vw,37:$Vx,38:$Vy,39:$Vz,40:$VA,41:$VB,42:$VC,43:$VD,44:$VE,47:$VH}),o($VI,[2,44])],
defaultActions: {20:[2,19],21:[2,20],22:[2,21],23:[2,22],24:[2,23],25:[2,24],26:[2,25],27:[2,26],28:[2,27],29:[2,28],30:[2,29],31:[2,30],32:[2,31],33:[2,1]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

    const Nodo = require('./Nodo').default;
    var arreglolexico = "Codigo:";


       
   
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:return 23;
break;
case 1:return 27;
break;
case 2:return 29;
break;
case 3:return 30;
break;
case 4:return 33;
break;
case 5:return 22;
break;
case 6:return 24;
break;
case 7:return 25;
break;
case 8:return 26;
break;
case 9:return 28;
break;
case 10:return 31;
break;
case 11:return 32;
break;
case 12:return 34;
break;
case 13:return 'null';
break;
case 14:return 'true';
break;
case 15:return 'false';
break;
case 16:return 56;
break;
case 17:return 53;
break;
case 18:return 57;
break;
case 19:return 58;
break;
case 20:return 38;
break;
case 21:return 45;
break;
case 22:return 46;
break;
case 23:return 47;
break;
case 24:return 6;
break;
case 25:return 36;
break;
case 26:return 37;
break;
case 27:return 17;
break;
case 28:return 39;
break;
case 29:return 40;
break;
case 30:return 41;
break;
case 31:return 42;
break;
case 32:return 43;
break;
case 33:return 44;
break;
case 34:return 54;
break;
case 35:return 55;
break;
case 36:return 59;
break;
case 37:return 60;
break;
case 38:return 9; //Probar Esto
break;
case 39:return 8;
break;
case 40:return 19;
break;
case 41:return 18;
break;
case 42:return 16;
break;
case 43:return 21;
break;
case 44:/*skip comment */
break;
case 45:/* skip whitespace */
break;
case 46:return 49;
break;
case 47:return 50;
break;
case 48:return 51;
break;
case 49:return 52;
break;
case 50:return 15;
break;
case 51:
                                       console.error('Este es un error léxico: ' + yy_.yytext + ', en la linea: ' + yy_.yylloc.first_line + ', en la columna: ' + yy_.yylloc.first_column);
                                   
break;
case 52:return 5;
break;
}
},
rules: [/^(?:ancestor-or-self\b)/i,/^(?:descendant-or-self\b)/i,/^(?:following-sibling\b)/i,/^(?:namespace-node\b)/i,/^(?:preceding-sibling\b)/i,/^(?:ancestor\b)/i,/^(?:attribute\b)/i,/^(?:child\b)/i,/^(?:descendant\b)/i,/^(?:following\b)/i,/^(?:parent\b)/i,/^(?:preceding\b)/i,/^(?:self\b)/i,/^(?:null\b)/i,/^(?:true\b)/i,/^(?:false\b)/i,/^(?:node\b)/i,/^(?:text\b)/i,/^(?:last\b)/i,/^(?:position\b)/i,/^(?:div\b)/i,/^(?:or\b)/i,/^(?:and\b)/i,/^(?:mod\b)/i,/^(?:\|)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:=)/i,/^(?:!=)/i,/^(?:<)/i,/^(?:<=)/i,/^(?:>)/i,/^(?:>=)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\[)/i,/^(?:\])/i,/^(?:\/\/)/i,/^(?:\/)/i,/^(?:\.\.)/i,/^(?:\.)/i,/^(?:@)/i,/^(?:::)/i,/^(?:(\(:((\\([\'\"\\bfnrtv]))|([^\:)\\]+)):\)))/i,/^(?:\s+)/i,/^(?:(([0-9]+\.[0-9]*)|(\.[0-9]+)))/i,/^(?:([0-9]+))/i,/^(?:("((\\([\'\"\\bfnrtv]))|([^\"\\]+))*"))/i,/^(?:('((\\([\'\"\\bfnrtv]))|([^\'\\]+))*'))/i,/^(?:[a-zA-Z_][a-zA-Z0-9_ñÑá-ü]*)/i,/^(?:.)/i,/^(?:$)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = gramatica;
exports.Parser = gramatica.Parser;
exports.parse = function () { return gramatica.parse.apply(gramatica, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}